export default __webpack_public_path__ + "static/media/36.fa8d60d7.png";